import { useGetSellerRequestByIdQuery } from '@/app/api';
import { getFetchEror } from '@/app/helpers';
import { CabinetWrapper } from '@/shared/cabinet-wrapper';
import ComponentWithLoader from '@/shared/ComponentWithLoader/ComponentWithLoader';
import { PageTitle } from '@/shared/page-title';
import { SingleDeal } from '@/shared/single-deal';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams, useSearchParams } from 'react-router-dom';

export const SingleSellerRequestPage = () => {
  const { t } = useTranslation();
  const { id = '' } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const backUrl = searchParams.get('backUrl');

  const { data, isLoading, error } = useGetSellerRequestByIdQuery(id, {
    skip: !id,
  });

  const isReverseFactoring = data?.data?.isReverseFactoring;

  return (
    <CabinetWrapper>
      {data ? (
        <ComponentWithLoader isLoading={isLoading}>
          <PageTitle
            title={t('request') + ` №${data.data.number}`}
            date={data.data.createdAt}
            sx={{ mb: 2.5 }}
            backUrl={encodeURIComponent(backUrl || '/seller/deals')}
          />
          <SingleDeal
            data={data?.data}
            factorBranch={data?.factor?.branch}
            type={isReverseFactoring ? 'buyer' : 'seller'}
          />
        </ComponentWithLoader>
      ) : (
        <Alert severity='error'>{getFetchEror(error)}</Alert>
      )}
    </CabinetWrapper>
  );
};
